// Port of api/fuel/app/classes/filter/search/games/filters/query/game/text.php
import Util from 'offline/util'
import F from 'offline/filter/constants'
import DB from 'offline/db'
export default {
	name: 'game.text',
	priority: 15,
	require: function(config, filter) {
		return filter.text && filter.text.length > 0
	},
	run: function(config, filter, data, query) {
		var text = Util.sortname(filter.text)
		var keywords = text.split(' ').filter(function(k) { return k !== undefined })
		if (!keywords.length) keywords = ['']

		if (config.resultType === F.RESULT_COLLECTION) query.join('game', 'g', 'JOIN')

		for (var i = 0; i < keywords.length; i++) {
			var keyword = keywords[i]
			var prefix = (keyword.length > 1 || keywords.length > 1) ? '%' : ''

			var versionGameIndex = []

			if (config.resultType === F.RESULT_COLLECTION && config.ownerType === F.OWNER_USER) {
				var versionRows = DB.query(
					'SELECT DISTINCT game_version_id FROM collection WHERE user_id IN(' + Util.in(config.users) + ') AND game_version_id > 0'
				)
				var versionIds = Util.pluck(versionRows, 'game_version_id')

				if (versionIds.length) {
					var vgRows = DB.query(
						'SELECT DISTINCT game_id FROM game_version WHERE LOWER(game_version_sort) LIKE \'' +
						(prefix + keyword.toLowerCase() + '%').replace(/'/g, "''") +
						'\' AND game_version_id IN(' + Util.in(versionIds) + ')'
					)
					versionGameIndex = Util.pluck(vgRows, 'game_id')
				}
			}

			var pattern = prefix + keyword.toLowerCase() + '%'

			if (versionGameIndex.length) {
				query.whereGroup('OR', [
					['g.game_id', 'in', versionGameIndex],
					['g.game_sortname', 'like', pattern]
				])
			} else {
				query.where('g.game_sortname', 'like', pattern)
			}
		}
	}
}
